import {useState, useEffect} from 'react'


function useDistanceFromParent(parentId, childId, deps=[]) {
    const [distanceFromParent, setDistanceFromParent] = useState(0)
  
    useEffect(() => {
      const calculateDistance = () => {

        const parent = document.getElementById(parentId)
        const child = document.getElementById(childId)
  
        if (!parent || !child) return;
        const parentRect = parent.getBoundingClientRect()
        const childRect = child.getBoundingClientRect()
        const newDistanceFromParent = childRect.left - parentRect.left;

        setDistanceFromParent(newDistanceFromParent);
      }
  
      calculateDistance();
  
      const handleResize = () => {
        calculateDistance()
      }

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      }

    }, [parentId, childId, ...deps]);
  
    return distanceFromParent;
  }

  export default useDistanceFromParent